export var EXPAND_COLUMN = {};
export var INTERNAL_HOOKS = 'rc-table-internal-hook';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/es/constant.js
// module id = 239
// module chunks = 0